import React, { useEffect, useRef } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { BrandContext } from "../../App";

import { useAuth } from "../../contexts/AuthContext";

const TranscriptDisplay = ({ transcript, scenarioData }) => {
  const theme = useTheme();
  const endRef = useRef(null);
  const { loggedInUser } = useAuth();
  useEffect(() => {
    if (endRef.current && endRef.current.parentNode) {
      const parent = endRef.current.parentNode;
      parent.scrollTop = parent.scrollHeight;
    }
  }, [transcript]);

  if (transcript == null) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          padding: theme.customSpacing["3xl"],
        }}
      >
        <CircularProgress />
        <Typography sx={{ ml: 2, color: theme.palette.text.brand_primary }}>
          Loading transcript...
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        padding: `${theme.customSpacing["3xl"]} 0`,
        backgroundColor: "#transparent",
        overflowY: "auto",
      }}
    >
      {transcript.map(({ id, message, ai_generated }) => {
        const author = ai_generated
          ? scenarioData?.avatar_persona?.name ?? "Avatar"
          : loggedInUser?.first_name || "You";
        return (
          <Box
            key={id || message}
            sx={{ marginBottom: theme.customSpacing.lg }}
          >
            <Typography
              sx={{
                fontWeight: theme.typography.fontWeightRegular,
                color: ai_generated
                  ? theme.palette.background.button_primary_hover
                  : theme.palette.border.brand,
              }}
            >
              {author}
            </Typography>
            <Typography
              sx={{
                color: theme.palette.text.brand_primary,
                fontWeight: theme.typography.fontWeightLight,
                fontSize: theme.typography.textSM.fontSize,
                lineHeight: theme.typography.textSM.lineHeight,
              }}
            >
              {message}
            </Typography>
          </Box>
        );
      })}
      <div ref={endRef} />
    </Box>
  );
};

export default TranscriptDisplay;
